import React from "react";
import '../styles/PatientDetail.css'
import { Button } from "antd";

const PatientDetail = (props) => {
    return (
        <div className="patient-detail-container">
            <div className="patient-detail">
                <p><span>MRN : </span> {props.patientDetail.mrn}</p>
                <p><span>Name : </span> {props.patientDetail.patient_name}</p>
                <p><span>Age/Gender : </span> {props.patientDetail.age} / {props.patientDetail.gender}</p>
                <p><span>Consultant : </span> {props.patientDetail.consultant}</p>
            </div>
            {props.isconfirmed ? <></> : <div className="button-container">
                <Button style={{ backgroundColor: '#5f0a10', color: 'white' }} onClick={() => { props.onconfirm(props.patientDetail) }}>Confirm</Button>
            </div>}
        </div>
    )
}
export default PatientDetail;